import BaseView from './BaseView';
import barba from '@barba/core';
import Modal from '../../components/Modal';
import {gsap} from "gsap";
import ImageCarousel from '../../modules/ImageCarousel';
import EventCarousel from '../../modules/EventCarousel';

let view = null;

class SingleEvent extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {

		new Modal();

		this.container.querySelectorAll('[data-back]').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();

				if (barba.history.previous && barba.history.previous.url.includes('/program')) {
					history.back();
				} else {
					barba.go(el.href);
				}
			});
		});

		this.container.querySelectorAll('[data-event-carousel]').forEach((el) => {
			this.modules.push(new EventCarousel(el));
		});

		this.container.querySelectorAll('[data-image-carousel]').forEach((el) => {
			this.modules.push(new ImageCarousel(el));
		});

		// Lagen effect
		this.topSection = this.container.querySelector('[data-event-top]');
		this.bottomSection = this.container.querySelector('[data-event-bottom]');

		// Calculate the height op the top section on resize
		this.boundCalculateTopPartHeight = this.calculateTopPartHeight.bind(this);
		window.addEventListener('resize', this.boundCalculateTopPartHeight);
		this.calculateTopPartHeight();

		this.setupScrolling();
	}

	setupScrolling() {
		// Animate the top overlay during a part of the bottom section scroll duration
		gsap.to(this.topSection.querySelector('[data-event-top-overlay]'), {
			opacity: 1,
			scrollTrigger: {
				trigger: this.bottomSection,
				start: () => {
					return `top-=${window.innerHeight - window.innerHeight * 1} bottom`;
				},
				end: () => {
					return `+=${window.innerHeight}`;
				},
				scrub: true,
			},
		});
	}

	calculateTopPartHeight() {
		// Set sticky position of top section as css variable
		this.topSection.style.setProperty(
			'--sticky-top',
			(this.topSection.clientHeight - document.documentElement.clientHeight) * -1 + 'px'
		);
	}
}

export default {
	namespace: 'single-event',
	beforeEnter: ({ current, next, trigger }) => {
		view = new SingleEvent(next.container);
		view.init();

		document.dispatchEvent(new CustomEvent('show-program-link-in-header'));
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;

		document.dispatchEvent(new CustomEvent('hide-program-link-in-header'));
	},
};
